const vertical = 'v';
const horizontal = 'h';
const float = 'f';
const loading = 'loading';
const classDenieSelection = 'denie-selection'
const initialBoxFormWidthInVerticalView = '430px';
let currentView = !(localStorage.getItem("view") === null) ? localStorage.getItem("view") : float
let webkitScreenX = 0;
const styleClasses = {
    elBoxPreview: 'box-preview',
    elBoxToggleView: 'box-toggle-view',
}

const elMainBox = document.querySelector('#c-main');
const elAdForm = document.querySelector('#adForm');
const elBoxBanner = document.querySelector('.box-banner')
const elHandleResize = document.querySelector('.handle-resize');
const elBody = document.querySelector("body");
let elBoxToggleview = document.querySelector('.box-toggle-view')
let elViewButton = document.querySelector('#toggle-view');
let elBoxPreview = document.querySelector('.box-preview')
let elCanvasContainer, //it will appear after full loading page
    conflictHeight,
    conflictWidth,
    initialCanvasContanerHeight,
    initialCanvasContanerWidth;
if (elViewButton) {
  document.querySelector('#navbarSupportedContent').insertAdjacentElement('afterbegin', elViewButton)
}

const viewToggleService = (value = float) => {
    localStorage.setItem("view", value);
    currentView = value;
    elMainBox.classList.remove(loading)
    document.querySelector('#toggle-view').value = value
    switch(value){
        case vertical:
            elMainBox.classList.add(vertical)
            elMainBox.classList.remove(horizontal)
            elMainBox.classList.remove(float)
            elAdForm.style.height = '';
            if (elCanvasContainer && initialCanvasContanerHeight) {
                elCanvasContainer.style.height = initialCanvasContanerHeight + 'px' 
            }
            elBody.classList.remove('bg-white')
            elBody.style.backgroundImage = `linear-gradient(to left, #f6f6f6, #f6f6f6 ${initialBoxFormWidthInVerticalView}, #fff ${initialBoxFormWidthInVerticalView}, #fff)`
            break;
        case horizontal:
            elMainBox.classList.add(horizontal)
            elMainBox.classList.remove(vertical)
            elMainBox.classList.remove(float)
            elAdForm.style.width = '';
            if (elCanvasContainer && initialCanvasContanerWidth) {
                elCanvasContainer.style.width = initialCanvasContanerWidth + 'px' 
            }
            document.querySelector("body").classList.add('bg-white')
            elBody.style.backgroundImage = ""
            break;
        case float:
            elMainBox.classList.add(float)
            elMainBox.classList.remove(vertical)
            elMainBox.classList.remove(horizontal)
            elBoxPreview.childNodes.forEach(el => elBoxBanner.insertAdjacentElement('beforeend', el))
            elBoxPreview.remove()
            elBoxPreview = undefined;
            elBoxToggleview.remove()
            elBoxToggleview = undefined
            elHandleResize.style.display = 'none'
            elAdForm.style.height = '';
            elAdForm.style.width = '';
            elBody.classList.remove('bg-white')
            break;
        default:
            break;
    }
}
const handleViewToggle = ({target}) => {
    viewToggleService(target.value)
}

const handleResize = (event) => {
    switch (currentView) {
        case horizontal:
            elAdForm.style.height = elAdForm.clientHeight - event.movementY + 'px'
            if (event.movementY < 0 && elAdForm.clientHeight - event.movementY >= conflictHeight) {
                elCanvasContainer.style.height = elCanvasContainer.clientHeight + event.movementY + 'px'
            }
            if (event.movementY > 0 && elCanvasContainer.clientHeight < initialCanvasContanerHeight) {
                elCanvasContainer.style.height = (elCanvasContainer.clientHeight + event.movementY <= initialCanvasContanerHeight)
                    ? elCanvasContainer.clientHeight + event.movementY + 'px'
                    : initialCanvasContanerHeight + 'px'
            }
            break;
        case vertical: {
            const movementX = webkitScreenX - event.screenX
            const elAdFormWidth = elAdForm.clientWidth + movementX + 'px'
            elAdForm.style.width = elAdFormWidth
            elBody.style.backgroundImage = `linear-gradient(to left, #f6f6f6, #f6f6f6 ${elAdFormWidth}, #fff ${elAdFormWidth}, #fff)`
            if (event.movementX < 0 && elAdForm.clientWidth - event.movementX >= conflictWidth) {
                elCanvasContainer.style.width = elCanvasContainer.clientWidth + event.movementX + 'px'
            }
            if (event.movementX > 0 && elCanvasContainer.clientWidth < initialCanvasContanerWidth) {
                elCanvasContainer.style.width = (elCanvasContainer.clientWidth + event.movementX <= initialCanvasContanerWidth)
                  ? elCanvasContainer.clientWidth + event.movementX + 'px'
                  : initialCanvasContanerWidth + 'px'
            }
            webkitScreenX = event.screenX
            break
        }
        default:
            break;
    }
}
const stopResize = () => {
    elAdForm.style.overflowY = 'scroll';
    document.removeEventListener('mousemove', handleResize)
    document.removeEventListener('mouseup', stopResize)
    elBoxBanner.classList.remove(classDenieSelection)
}

const startResize = (event) => {
    elCanvasContainer = document.querySelector('.canvas-container')
    initialCanvasContanerHeight = initialCanvasContanerHeight || elCanvasContainer.clientHeight;
    initialCanvasContanerWidth = initialCanvasContanerWidth || elCanvasContainer.clientWidth;
    conflictHeight = elBoxBanner.clientHeight - elBoxToggleview.clientHeight - elBoxPreview.clientHeight
    conflictWidth = elBoxBanner.clientWidth - elBoxPreview.clientWidth
    webkitScreenX = event.screenX
    elAdForm.style.overflowY = 'hidden';
    document.addEventListener('mousemove', handleResize)
    document.addEventListener('mouseup', stopResize)
    elBoxBanner.classList.add(classDenieSelection)
}

if (!!elViewButton && !!elMainBox && !!elHandleResize && !!elAdForm && !!elBoxBanner) {
    elViewButton.addEventListener('change', handleViewToggle)
    elHandleResize.addEventListener('mousedown', startResize)
    viewToggleService(currentView)
}

// show layout page (vertical)
// const elSectionForm = document.querySelector('.section-form');
// const elHandleResizeIcon = document.querySelector('.handle-resize-icon');
// const grid = document.querySelector('#template-group-preview');
//
// const startLayoutShowResize = (event) => {
//     webkitScreenX = event.screenX
//     document.addEventListener('mousemove', handleResizeLayoutShow);
//     document.addEventListener('mouseup', stopLayoutShowResize);
// }
//
// const stopLayoutShowResize = () => {
//     document.removeEventListener('mousemove', handleResizeLayoutShow);
//     document.removeEventListener('mouseup', stopLayoutShowResize);
//     console.log('removed events');
// }
//
// const handleResizeLayoutShow = (event) => {
//     console.log('mouse move event');
//     if (!!event.movementX) {
//         elSectionForm.style.width = elSectionForm.clientWidth - event.movementX + 'px'
//     }
// }
//
// if (!!elSectionForm && !!elHandleResizeIcon) {
//     elHandleResizeIcon.addEventListener('mousedown', startLayoutShowResize);
// }
// show layout page (fly text editor)
const dragElement = (element, dragHandlerId) => {
    let pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    
    if (document.getElementById(dragHandlerId)) {
        // if present, the header is where you move the DIV from:
        document.getElementById(dragHandlerId).onmousedown = dragMouseDown;
    } else {
        // otherwise, move the DIV from anywhere inside the DIV:
        element.onmousedown = dragMouseDown;
    }

    function dragMouseDown(event) {
        event = event || window.event;
        event.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = event.clientX;
        pos4 = event.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
    }

    function elementDrag(event) {
        event = event || window.event;
        event.preventDefault();
        // calculate the new cursor position:
        const width = $(element).width();
        const height = $(element).height();
        pos1 = pos3 - event.clientX;
        pos2 = pos4 - event.clientY;
        pos3 = event.clientX;
        pos4 = event.clientY;
        // set the element's new position:
        let top = Math.min(element.offsetTop - pos2, window.innerHeight - height);
        top = Math.max(0, top);
        element.style.top = top + "px";
        let left = Math.min(element.offsetLeft - pos1, window.innerWidth - width);
        left = Math.max(0, left);
        element.style.left = left + "px";
        element.style.right = "auto";
    }

    function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
    }
}

const textEditorControl = document.getElementById('text-editor-control');

if (textEditorControl) {
    dragElement(textEditorControl, 'text-editor-dragable');
}
